const {jQuery: $} = window;

import Utils from "./utils.class";
import MarketoValidator from "./MarketoValidator.class";
import MarketoPlugin from "./MarketoPlugin.class";

export default class Marketo {
    #id;
    #domain;
    #url;
    #marketoLoaded = false;
    #blockedDomains;
    #freeEmailDomains;
    #formAutosetValues;
    #plugins = [];

    constructor(id, domain, mktoHost, bannedDomains, freeDomains, autoValues) {
        this.#id = id;
        this.#domain = domain;
        this.#url = mktoHost;
        this.#blockedDomains = bannedDomains;
        this.#freeEmailDomains = freeDomains;
        this.#formAutosetValues = autoValues;

        Utils.log("Registered: Marketo (" + id + ")");

        $(window).on("load", function () {
            setTimeout(function () {
                $(".js-mkto-hide").show();
            }, 3000);
        });

        $(window).one("kmdg_marketo_ready", () => {
            $(".js-mkto-hide").addClass("js-hidden");
            this.#initPlugins();
        });
    }

    load() {
        // Async load marketo forms and set up global email validation rules

        Utils.log("Loading Marketo...");
        const self = this;

        if (!this.#marketoLoaded) {
            this.#marketoLoaded = true;

            $.getScript("https://" + this.#url + "/js/forms2/js/forms2.js", () => {
                Utils.log("Loaded Forms2.js");

                MktoForms2.whenReady((form) => {
                    Utils.log("Marketo Ready");
                    this.#floatLabel('.mktoFormRow .mktoField');
                    let urlParams = Utils.URLSearchParams;
                    let utm_medium = this.#formAutosetValues[urlParams.get("utm_medium")];

                    form._emailValidation = false;

                    form.addHiddenFields({
                        "utm_campaign": urlParams.get("utm_campaign"),
                        "utm_medium": urlParams.get("utm_medium"),
                        "utm_source": urlParams.get("utm_source"),
                        "utm_content": urlParams.get("utm_content"),
                        "utm_term": urlParams.get("utm_term"),
                        "utm_campaign__c": urlParams.get("utm_campaign"),
                        "utm_medium__c": urlParams.get("utm_medium"),
                        "utm_source__c": urlParams.get("utm_source"),
                        "utm_content__c": urlParams.get("utm_content"),
                        "utm_term__c": urlParams.get("utm_term"),
                        "gCLIDValue": "",
                        "leadSourceMR": "",
                    });

                    if (utm_medium === undefined) {
                        Utils.log("Autofilling Lead Source: Web");
                        form.setValues({'leadSourceMR': 'Web'});
                    } else {
                        Utils.log("Autofilling Lead Source: ", utm_medium);
                        form.setValues({'leadSourceMR': utm_medium});
                    }

                    try {
                        form.setValues({"gCLIDValue": ga.getAll()[0].get("clientId")});
                    } catch (e) {
                        Utils.log("Unable to set clientId");
                    }

                    form.getFormElem().find(".mktoEmailField").on('change', () => {
                        form._emailValidation = false;
                    });

                    form.getFormElem().find('.mktoButton').on('click', function () {
                        let $btn = $(this);
                        setTimeout(function () {
                            $btn.attr("disabled", "disabled");
                        }, 1);
                    });

                    form.onValidate((success) => {
                        Utils.log("Marketo Validation: ", success);

                        if (!success) {
                            // Restore access to the button after a few moments.
                            setTimeout(() => {
                                form.getFormElem().find('.mktoButton').removeAttr("disabled");
                            }, 3000);
                        }
                    });

                    form.onSubmit(() => {
                        let success = form.validate();

                        Utils.log("Running Custom Validation...");

                        success = MarketoValidator.runTasks(form, success);

                        Utils.log("Validation results: ", success ? "Success" : "Failed");

                        form.submittable(success);

                        if (!success) {
                            // Restore access to the button after a few moments.
                            setTimeout(function () {
                                form.getFormElem().find('.mktoButton').removeAttr("disabled");
                            }, 3000);
                        }

                        setTimeout(function () {
                            form.submittable(true);
                        }, 1);
                    });
                });

                MarketoValidator.registerTask("Default Validation", function ($) {
                    let email = this.vals().Email || this.vals().Email_Address_L__c;

                    if (email) {
                        if (!Utils.isEmailGood(self.#blockedDomains, email)) {
                            // Found competitor email, fake thank you message.
                            this.getFormElem().html("<p style='text-align: center;font-size: 100%;'>Thank you for your interest, you will hear from us soon.</p>");
                            return false;
                        } else if (!Utils.isEmailGood(self.#freeEmailDomains, email)) {
                            let $emailEl = this.getFormElem().find(".mktoEmailField");

                            Utils.log("Email Error: Not business email.");

                            // Allow marketo errors to be displayed until the next time the field is clicked on (conflict with this.#neverbounce)
                            $emailEl.parent().addClass("show_errors").one("click", function () {
                                $(this).removeClass('show_errors');
                            });

                            this.showErrorMessage("Please enter a business email.", $emailEl);
                            return false;
                        }
                    }

                    return true;
                });

                Utils.log("Marketo Fully loaded.");
                $(window).trigger("kmdg_marketo_ready", [this, MarketoValidator]);
            });
        } else {
            Utils.log("Marketo already loaded.")
        }
    }

    #floatLabel(inputType) {
        $(inputType).each(function () {
            let $this = $(this);
            $this.attr('placeholder', '');
            if (!$this.children().first().val()) {
                $this.children().first().text('');
            }
            const $parent = $this.closest('.mktoFieldWrap');
            if ($this.attr('type') === 'checkbox') {
                $parent.addClass('active');
                $parent.addClass('override');
            }
        });

        $(document).on('change', function () {
            $(inputType).each(function () {
                let $this = $(this);
                $this.attr('placeholder', '');
                if (!$this.children().first().val()) {
                    $this.children().first().text('');
                }
                const $parent = $this.closest('.mktoFieldWrap');
                if ($this.attr('type') === 'checkbox') {
                    $parent.addClass('active');
                    $parent.addClass('override');
                }
            });
        })

        $(document).on("focus", inputType, (function () {
                let $this = $(this);
                const $parent = $this.closest('.mktoFieldWrap');
                if ($this.attr('name') !== 'optinconsent') {
                    $parent.addClass('active').addClass('focus');
                    $this.addClass('focused');
                }
            }
        ));

        $(document).on("blur", inputType, (function () {
            let $this = $(this);
            const $parent = $this.closest('.mktoFieldWrap');
            $parent.removeClass('focus')
            $this.removeClass('focused');
            if (($this.val() === '' || $this.val() === 'blank') && ($this.attr('type') !== 'checkbox')) {
                $parent.removeClass('active')
            }
        }));
    }

    #initPlugins() {
        // Wait for signal that marketo is ready before loading plugins

        Utils.log("Loading Form Plugins...");

        $.getScript(location.protocol + "//" + location.host + "/wp-content/themes/kmdg/dist/js/SimpleDTO.min.js", () => {
            Utils.log("Mkto: Simple DTO loaded.");

            try {
                const DTO = new SimpleDTO({
                    domain: this.#domain,
                    dataSrc: "https://" + this.#url + "/dtp.html",
                    debug: true,
                    mode: "receive",
                    cb: (instance) => {
                        try {
                            const mktoFields = DTO.getGlobal()["mktoPreFillFields"];
                            DTO.cleanup();
                            MktoForms2.whenReady(function (form) {
                                const inputs = $('.mktoForm').find('.mktoField');
                                form.setValuesCoerced(mktoFields);
                                // Loop through prefilled inputs to apply active states
                                Array.prototype.forEach.call(inputs, input => {
                                    if (input && input.value) {
                                        $(input).parent('.mktoFieldWrap').addClass('active')
                                        $(input).addClass('mktoValid').change();
                                    }
                                })
                                Utils.log("Mkto: Prefilled fields.", mktoFields);
                                $(window).trigger("kmdg_marketo_dto_loaded", [form]);
                            });
                        } catch (e) {
                            Utils.log("Mkto: Could not pre-populate form.");
                            Utils.log(instance.getSource().href);
                            MktoForms2.whenReady(function (form) {
                                $(window).trigger("kmdg_marketo_dto_loaded", [form]);
                            });
                        }
                    }
                });
            } catch (e) {
                Utils.log("DTO Failed to load (expected when not on main domain)");
            }
        });

        for (let i in this.#plugins) {
            Utils.log("Loading Mkto plugin:", this.#plugins[i].name, this.#plugins[i].class);

            if (this.#plugins[i].class.marketoIntegration) {
                this.#plugins[i].class.marketoIntegration();
            } else {
                Utils.log("Error! Invalid plugin.");
            }
        }
    }

    registerPlugin(name, instance) {
        Utils.log("Registered Mkto plugin:", name);

        this.#plugins.push({
            name: name,
            class: instance
        });
    }

    get url() {
        return this.#url;
    }

    get id() {
        return this.#id;
    }
}